import React from "react";

const Hero = ({ image, children }) => {
  return (
    <div className="relative w-full">
      <img
        src={image}
        alt="Vaikunta Ekadashi Banner"
        className="w-full h-auto object-cover lg:mt-10"
      />
      {children}
    </div>
  );
};

export default Hero;
